import { createFileRoute } from '@tanstack/react-router'

import { Heading1 } from '@hap/components'

import { Library } from './-components/library'

export const Route = createFileRoute('/_authenticated/$alias/v2/scorecard/$scorecardId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()

  return (
    <div>
      <Heading1>Create dataset</Heading1>
      <Library scorecardId={params.scorecardId} />
    </div>
  )
}
